import React from 'react';
import '../styles/hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <div className="hero">
      <h1 className='heroHead'>Welcome to MovieNite</h1>
      <p className='heroSub'>What're we watchin'?</p>

      <div className='heroBtns'>
       <Link to={"/Movie"}> <button className='heroBtn'>Search Our Movies</button></Link>
      </div>
    </div>
  );
};

export default Hero;
